import HotkeyField from "./HotkeyField";

export default HotkeyField;
